import React from 'react';
import { connect } from 'react-redux';
import Timer from '@common/timer';
import { analyticsService } from '@common/analytics';
import Const from '../../config/const';
import withPGTranslation from '../../config/withPGTranslation';
import classesModule from './classes.module.scss';
import {
  hangupVoipChat, setEnableMic, setEnableVideo
} from '../../actions/voip_chat';
import Switch from '../../../common/helpers/switch';
import { renderNameAndDiscountLabel } from './voip_utils';

const kMuteActive = require('./img/mic_active.png');
const kMuteNotActive = require('./img/mic_non_active.png');

const kHangupIc = require('./img/ic_phone.png');

const cameraNotActive = require('./img/camera_non_active.svg');
const cameraActive = require('./img/camera_active.svg');
const micNotActive = require('./img/mic_non_active.svg');
const micActive = require('./img/mic_active.svg');

const renderVoiceMuteButton = (micEnabled, setMicEnabled) => {
  const muteIcon = micEnabled ? kMuteNotActive : kMuteActive;
  const muteClassName = micEnabled
    ? classesModule.muteNotActiveButton : classesModule.muteActiveButton;
  return (
    <div>
      <button
        type="button"
        onClick={ () => setMicEnabled(!micEnabled) }
        className={ muteClassName }
      >
        <img
          className={ classesModule.muteIcon }
          src={ muteIcon }
          alt=""
        />
      </button>
    </div>
  );
};

const renderVideoSwitcher = (
  micEnabled,
  videoEnabled,
  setMicEnabled,
  setVideoEnabled,
  trackMPEvent,
  advisorId,
  orderId
) => (
  <div>
    <div style={ { marginBottom: 10, marginTop: 2 } }>
      <Switch
        id="voipCameraSwitcher"
        checked={ videoEnabled }
        onChange={ () => {
          setVideoEnabled(!videoEnabled);
          if (!videoEnabled) {
            trackMPEvent({
              'advisor id': advisorId,
              'order id': orderId
            });
          }
        } }
        offColor="rgb(255, 255, 255, 0.16)"
        onColor="rgb(255, 255, 255, 0.16)"
        offSliderImg={ cameraNotActive }
        onSliderImg={ cameraActive }
        offSliderColor="rgb(255, 255, 255, 0.16)"
        onSliderColor="#16C5F0"
        width={ 50 }
        height={ 25 }
        handleDiameter={ 22 }
      />
    </div>
    <div>
      <Switch
        id="voipMicSwitcher"
        checked={ micEnabled }
        onChange={ () => setMicEnabled(!micEnabled) }
        offColor="rgb(255, 255, 255, 0.16)"
        onColor="rgb(255, 255, 255, 0.16)"
        offSliderImg={ micNotActive }
        onSliderImg={ micActive }
        offSliderColor="rgb(255, 255, 255, 0.16)"
        onSliderColor="#16C5F0"
        width={ 50 }
        height={ 25 }
        handleDiameter={ 22 }
      />
    </div>
  </div>
);

const renderReconnectLabel = (reconnecting) => {
  if (!reconnecting) return null;
  return (
    <div className={ classesModule.reconnectLabel }>
      <div className={ classesModule.timerWrapper }>
        <div className={ classesModule.setupLabel }>Trying to reconnect...</div>
      </div>
    </div>
  );
};

const renderHangupButton = (hangupCall) => (
  <div>
    <button
      type="button"
      onClick={ hangupCall }
      className={ classesModule.hangupButton }
    >
      <img
        className={ classesModule.hangupIcon }
        src={ kHangupIc }
        alt=""
      />
    </button>
  </div>
);

const renderDiscountLabelIfNeed = ({
  voipType, discountData, name, t
}) => {
  if (voipType !== Const.chatType.video) return null;
  return renderNameAndDiscountLabel({
    voipType, discountData, name, t
  });
};

function VoipControls({
  voipType,
  t,
  hangupChat,
  trackMPEvent,
  advisorId,
  orderId,
  enableMic,
  enableVideo,
  toggleMic,
  toggleVideo,
  reconnecting,
  discountData,
  name,
  timerEvents = {}
}) {
  const switcherContent = voipType === Const.chatType.video
    ? renderVideoSwitcher(
      enableMic,
      enableVideo,
      toggleMic,
      toggleVideo,
      trackMPEvent,
      advisorId,
      orderId
    ) : renderVoiceMuteButton(enableMic, toggleMic);
  return (
    <div className={ classesModule.controlsContainer }>
      { renderReconnectLabel(reconnecting) }
      { renderDiscountLabelIfNeed({
        voipType, discountData, name, t
      }) }
      <div className={ classesModule.controlsHolder }>
        { renderHangupButton(hangupChat) }
        { switcherContent }
      </div>
      <div className={ classesModule.timerWrapper }>
        <Timer callType="voip_chat" includeHours showIndicator events={ timerEvents } />
      </div>
    </div>
  );
}

const mapStateToProps = ({ voipChat }, props) => ({ ...voipChat, ...voipChat.conversationOption, ...props });

const mapDispatchToProps = (dispatch) => ({
  hangupChat: () => dispatch(hangupVoipChat()),
  toggleMic: (enable) => dispatch(setEnableMic(enable)),
  toggleVideo: (enable) => dispatch(setEnableVideo(enable)),
  trackMPEvent: (eventProperties) => analyticsService.trackEvent('vc mute video', eventProperties)
});

export default connect(mapStateToProps, mapDispatchToProps)(withPGTranslation(VoipControls));
